export default __webpack_public_path__ + "static/media/celebrate.d8cd8ff41152074af003d9cb763adf28.svg";